<template>
  <div class="opc-coupon__wrap __PLACEHOLDER_coupon__" v-if="isShowCoupon">
    <!-- for special support all product/transaction coupon form -->
    <support-coupon-form v-if="showSpecialSupportCouponForm" />
    <!-- for regular coupon form -->
    <template v-else-if="showRegularCouponForm">
      <zm-button class="opc-coupon__add--coupon" v-if="initMode" type="link" @click="switchToEditMode">
        {{ $t('billing.coupon.add_coupon_code') }}
      </zm-button>
      <opc-coupon-form ref="couponForm" v-else />
    </template>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import OpcCouponForm from '@/views/config/coupon/coupon-form';
import { couponFormModeMap } from '@/views/config/coupon/helper/constant';
import { isEmptyVal } from '@/utils';
import SupportCouponForm from '@/views/config/coupon/component/support-coupon/support-coupon-form.vue';
import { SupportCouponModeMap } from '@/views/config/coupon/component/support-coupon/constant';

export default {
  components: { SupportCouponForm, OpcCouponForm },
  computed: {
    ...mapGetters(['couponFormMode', 'couponState', 'isFromPartnerRefer', 'fromCampaignLink', 'forNewSubscriptionFlow', 'partnerRefer', 'eligiblePartnerReferOffer', 'useSpecialSupportCoupon', 'supportCouponState']),
    initMode() {
      return this.couponFormMode === couponFormModeMap.INIT;
    },
    isShowCouponWithPartner() {
      const partnerRefer = this.partnerRefer;
      const partnerReferRules = partnerRefer?.rules;

      // for replace subscription &
      // partner refer just validate by referral coupon code not redeem this coupon
      if (
        partnerReferRules?.validateByReferralCoupon
        && !isEmptyVal(partnerRefer?.referralCouponCode)
        && !this.forNewSubscriptionFlow
      ) {
        return false;
      }

      // allow zoom coupon with partner refer
      if (partnerReferRules?.allowUseZMCoupon) {
        return true;
      }

      if (this.eligiblePartnerReferOffer) {
        return false;
      }

      // replace subscription
      if (!this.forNewSubscriptionFlow) {
        return false;
      }

      return true;
    },
    showRegularCouponForm() {
      if (this.isFromPartnerRefer) {
        return this.isShowCouponWithPartner;
      }

      if (this.forNewSubscriptionFlow) {
        return true;
      }

      if (this.fromCampaignLink) {
        return true;
      }

      return false;
    },
    showSpecialSupportCouponForm() {
      if (this.supportCouponState?.couponDisplayMode !== SupportCouponModeMap.form) {
        return false;
      }

      if (this.useSpecialSupportCoupon) {
        return true;
      }

      return false;
    },
    isShowCoupon() {
      return this.showSpecialSupportCouponForm || this.showRegularCouponForm;
    }
  },
  methods: {
    ...mapMutations(['setCouponFormMode']),
    switchToEditMode() {
      this.setCouponFormMode(couponFormModeMap.EDIT);
      this.$nextTick(() => this.$refs?.couponForm?.focus());

      this.$tracking.buyInteraction(
        'order summary',
        'add coupon code'
      )
    },
  },
  watch: {
    'couponState.couponCode': {
      immediate: true,
      handler(couponCode) {
        couponCode && this.setCouponFormMode(couponFormModeMap.EDIT);
      },
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';

.opc-coupon {
  &__add--coupon {
    padding: 0px;
    font-weight: 700;
    font-size: 14px;

    @include media(desktop) {
      scroll-margin-bottom: 200px;
    }

    &.zm-button--link {
      color: $theme-color;
    }
  }
}
</style>
